
        // Load Supabase from CDN and expose globally
        // Use a specific version for stability
        // Fallback to jsdelivr if esm.sh fails
        let createClient;
        try {
            const module = await import('https://esm.sh/@supabase/supabase-js@2.39.0');
            createClient = module.createClient;
            console.log('✅ Supabase loaded from esm.sh');
        } catch (error) {
            console.warn('⚠️ esm.sh failed, trying jsdelivr fallback:', error);
            try {
                const module = await import('https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2.39.0/+esm');
                createClient = module.createClient;
                console.log('✅ Supabase loaded from jsdelivr (fallback)');
            } catch (fallbackError) {
                console.error('❌ Failed to load Supabase from all CDNs:', fallbackError);
                // Still expose a stub so the app doesn't crash completely
                createClient = () => {
                    throw new Error('Supabase CDN unavailable. Please refresh the page.');
                };
            }
        }
        window.SupabaseClient = { createClient };
        // Signal that Supabase is ready
        window.dispatchEvent(new Event('supabaseReady'));
    